export const states = [
  {
    label: 'Baden-Württemberg',
    value: 'BW',
  },
  {
    label: 'Bayern',
    value: 'BY',
  },
  {
    label: 'Berlin',
    value: 'BE',
  },
  {
    label: 'Brandenburg',
    value: 'BB',
  },
  {
    label: 'Bremen',
    value: 'HB',
  },
  {
    label: 'Hamburg',
    value: 'HH',
  },
  {
    label: 'Hessen',
    value: 'HE',
  },
  {
    label: 'Mecklenburg-Vorpommern',
    value: 'MV',
  },
  {
    label: 'Niedersachsen',
    value: 'NI',
  },
  {
    label: 'Nordrhein-Westfalen',
    value: 'NW',
  },
  {
    label: 'Rheinland-Pfalz',
    value: 'RP',
  },
  {
    label: 'Saarland',
    value: 'SL',
  },
  {
    label: 'Sachsen',
    value: 'SN',
  },
  {
    label: 'Sachsen-Anhalt',
    value: 'ST',
  },
  {
    label: 'Schleswig-Holstein',
    value: 'SH',
  },
  {
    label: 'Thüringen',
    value: 'TH',
  },
  {
    label: 'Foreign State',
    value: 'FOREIGN',
  },
];
